import type { Firestore } from '../../../../../src/types/firebase'

export const getInternalToExternalActivitiesByBusinessId = (db: Firestore, businessId: string) =>
  db.collection('business').doc(businessId).collection('activities').where('popUpAnswered', '==', false)

export const getPushToExternalBusinessActivityByActivityId = (db: Firestore, businessId: string, activityId: string) =>
  db.collection('business').doc(businessId).collection('activities').doc(activityId)
